import DashboardMain from './DashboardMain';

export default DashboardMain;
